import { FC } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

type IMode = "resetPassword" | "recoverEmail" | "verifyEmail";

export const ActionsRoute: FC = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") as IMode | null;

  switch (mode) {
    case "verifyEmail":
      return <Navigate to={`/verify-email?${searchParams.toString()}`} />;
    case "resetPassword":
      return <Navigate to={`/reset-password?${searchParams.toString()}`} />;
  }
  return <></>;
};
